import "./App.css";
import Welcome from "./components/Welcome";
import HomePage from "./components/HomePage";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route exact path="/">
            <Welcome />
          </Route>
          <Route exact path="/homepage">
            <HomePage />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
